import React from "react";
import './TableComponent.scss'
interface TableComponentProps {
    data: any[]
    columns: any[]
}

const TableComponent: React.FC<TableComponentProps> = ({ columns, data }) => {
    return <div className="table-wrapper">
        {columns.map((column, colIndex) => (
            <div key={colIndex} className="table-row">
                <div className="table-cell header-cell">{column}</div>
                {data.map((row, rowIndex) => (
                    <div key={rowIndex} className="table-cell">
                        {row[column]}
                    </div>
                ))}
            </div>
        ))}
    </div>
}

export default TableComponent;
